import { message } from "antd";
import { useState } from "react";
import { patchUserInfo } from "../service/auth.service";
import { setUserInfo } from "../slices/authSlice";
import { useAppDispatch, useAppSelector } from "./redux-hooks";

/** Record-first preference, saved on toggle so Settings and the intro popover stay in step. */
export const useRecordFirst = () => {
  const dispatch = useAppDispatch();
  const userInfo = useAppSelector((state) => state.auth.userInfo);
  const [saving, setSaving] = useState(false);
  const enabled = !!userInfo.record_first;

  const setEnabled = async (checked: boolean) => {
    setSaving(true);
    dispatch(setUserInfo({ ...userInfo, record_first: checked }));
    try {
      await patchUserInfo({ record_first: checked });
    } catch {
      dispatch(setUserInfo({ ...userInfo, record_first: !checked }));
      message.error("Couldn't save your preference. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return { enabled, setEnabled, saving };
};
